// extracted by mini-css-extract-plugin
export default {"small":"logo_small__dcZtr","medium":"logo_medium__8qop-","large":"logo_large__7CYjH"};